// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Meta from 'vue-meta'
import get from 'lodash/get'
import './assets/vendor/font-awesome/css/all.css'
import './bootstrap'
import queryStringParser from '@/helpers/QueryStringParser'
import VkMiniApp from '@/vk/VkMiniApp'
import storage from '@/storage'

Vue.use(Meta)

Vue.config.productionTip = false

const odrEnabled = parseInt(queryStringParser.get('odr_enabled'), 10) === 1
const vkGroupId = parseInt(queryStringParser.get('vk_group_id'), 10)
const vkMiniApp = new VkMiniApp(odrEnabled, vkGroupId)
const deliveryMethod = queryStringParser.get('delivery_method')

if (deliveryMethod) {
  storage.deliveryMethod(deliveryMethod)
}

vkMiniApp.execute().then(() => {
  import('@/factory').then(module => {
    const app = module.default

    app.$mount('#app')

    if (odrEnabled && vkGroupId) {
      app.$router.replace({ name: 'home' }).then(() => vkMiniApp.init())
    } else {
      vkMiniApp.init()
    }

    const designerToken = get(window, '__appState.designer.token') || queryStringParser.get('designer-token')

    if (designerToken) {
      import('@/designer/init').then(module => module.default(app, designerToken))
    }

    console.log(`[Storefront] App mounted with tabId "${app.$store.getters['ui/tabId']}"`);
  })
})
